var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.shown
      ? _c(
          "div",
          { staticClass: "modal" },
          [
            _vm.shown
              ? _c("div", {
                  staticClass: "modal-dimmer",
                  on: { click: _vm.closeModal }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fadeDown" } }, [
              _vm.fadeIn
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "box" }, [
                      _c(
                        "span",
                        { staticClass: "close", on: { click: _vm.closeModal } },
                        [_c("i", { staticClass: "close icon" })]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-header" }, [
                        _vm.icons
                          ? _c("i", { staticClass: "icons" }, [
                              _c("i", { class: [_vm.icons, "icon"] }),
                              _vm._v(" "),
                              _vm.totalnotifications > 0
                                ? _c(
                                    "i",
                                    {
                                      staticClass:
                                        "ui blue circular label top right"
                                    },
                                    [_vm._v(_vm._s(_vm.totalnotifications))]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.title) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "box-content" },
                        [_vm._t("default")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.showButtons
                        ? _c(
                            "div",
                            { staticClass: "box-actions" },
                            [
                              _vm._t("box-actions", function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ui basic circular red button",
                                      on: { click: _vm.denyModal }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("globals.buttons.cancel"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui blue circular button",
                                      class: _vm.acceptButtonDisabled
                                        ? "disabled"
                                        : "",
                                      on: { click: _vm.acceptModal }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("globals.buttons.next"))
                                      )
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3db6d1c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3db6d1c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/Modal.vue
// module id = JRzt
// module chunks = 1